import { render } from "./ManageAction.vue?vue&type=template&id=34d4be04&scoped=true"
import script from "./ManageAction.vue?vue&type=script&lang=js"
export * from "./ManageAction.vue?vue&type=script&lang=js"

import "./ManageAction.vue?vue&type=style&index=0&id=34d4be04&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d4be04"]])

export default __exports__